import { render, staticRenderFns } from "./coupon-new.vue?vue&type=template&id=2cf73d9a"
import script from "./coupon-new.vue?vue&type=script&lang=js"
export * from "./coupon-new.vue?vue&type=script&lang=js"
import style0 from "./coupon-new.vue?vue&type=style&index=0&id=2cf73d9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports